import { observer } from 'mobx-react-lite'
import { PresetCard, PresetGrid } from 'shared/Preset'
import { ChatbotInstructionType } from 'entities/Chatbot'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { TextingTemplates } from 'pages/chatbot/config'

import styles from './styles.module.scss'

type ITextingContentProps = {
  selectedType: ChatbotInstructionType
  onSelectType: (type: ChatbotInstructionType) => void
}

export const TextingContent = observer(({ selectedType, onSelectType }: ITextingContentProps) => {
  const {
    featureFlagsStore: { salesmsg_ai_agent_book_appointment_v2 },
  } = useEntitiesContext()

  const templates = salesmsg_ai_agent_book_appointment_v2
    ? TextingTemplates
    : TextingTemplates.filter(
        (template) => template.type !== ChatbotInstructionType.BookAppointment
      )

  return (
    <PresetGrid className={styles.presetGrid}>
      {templates.map((template) => (
        <PresetCard
          key={template.type}
          icon={template.icon}
          name={template.name}
          description={template.description}
          selected={template.type === selectedType}
          onClick={() => onSelectType(template.type)}
          badge={template.isNew ? 'new' : undefined}
        />
      ))}
    </PresetGrid>
  )
})
